export const SocialAccountsFooterLabels = {
  firstStepPrev: "Cancel",
  firstStepNext: "Next",
  firstStepSave: "Save",
  finalStepPrev: "Previous",
  finalStepNext: "Connect"
};
